import { bytesToNDigits } from '@mail/cross-sizes-utils';
import { classNames } from '@vkontakte/vkui';
import React, { useRef } from 'react';
import { emitAnalyticEvent } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';
import { multiTariffHighlightMobile } from 'reactApp/appHelpers/featuresHelpers/features/multiTariffMobile';
import { SPACE_LIST } from 'reactApp/constants/spaceList';
import styles from 'reactApp/sections/QuotaLanding/MultiTariffsListMobile/MultiTariffsListMobile.css';
import { sendQuotaGa } from 'reactApp/sections/QuotaLanding/QuotaLanding.helpers';
import type { Product } from 'reactApp/types/Billing';
import { ETabsName } from 'reactApp/ui/TariffSectionNew/TariffSection.constants';

interface MultiTariffsListMobileSpaceCardProps {
    yearProduct?: Product;
    index?: number;
    withActionTariff?: boolean;
    activeTariffTab?: ETabsName;
    currentSpace: number;
    space: number;
    onClick: () => void;
}

export function MultiTariffsListMobileSpaceCard({
    index,
    space,
    currentSpace,
    activeTariffTab,
    withActionTariff,
    yearProduct,
    onClick,
}: MultiTariffsListMobileSpaceCardProps) {
    const ref = useRef<HTMLDivElement>(null);
    return (
        <div
            ref={ref}
            className={classNames(styles.tariff, {
                [styles.tariffActive]: space === currentSpace,
                [styles.tariff_highlight]: multiTariffHighlightMobile,
                [styles.tariff_family_highlight]: multiTariffHighlightMobile && activeTariffTab === ETabsName.family,
                [styles.tariff_for_work_highlight]: multiTariffHighlightMobile && activeTariffTab === ETabsName.for_work,
                [styles.tariff_highlight_bf2025]: withActionTariff && space === SPACE_LIST.tb_1,
            })}
            onClick={() => {
                emitAnalyticEvent(AnalyticEventNames.MULTITARIFF_SIZE_CLICK_M);
                sendQuotaGa({
                    action: 'change-tariff',
                    name_button_from: activeTariffTab,
                    tariff: yearProduct?.id,
                });
                onClick();
                requestAnimationFrame(() => ref.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }));
            }}
        >
            <div className={styles.value}>{bytesToNDigits(space, 3).space}</div>
            <div className={styles.units}>{bytesToNDigits(space, 3).units}</div>
            {/* хз какое тут условие для шильдика 'Выгодно' мб что-то посложнее надо */}
            {(withActionTariff ? space === SPACE_LIST.tb_1 : index === 0) && (
                <div
                    className={classNames(styles.label, {
                        [styles.label_bf2025]: withActionTariff,
                        [styles.label_bf2025_active]: withActionTariff && currentSpace === SPACE_LIST.tb_1,
                    })}
                >
                    Выгодно
                </div>
            )}
        </div>
    );
}
